import { computed, inject, provide, reactive, ref, watch, getCurrentInstance } from "vue";
import { ItemStatus, Links } from "../data/template";
import { defaultTemplate } from "@/api/daily";
import { useGetLink } from "./getAddForm";
import { message } from "ant-design-vue";
export function getDetail(props, emits) {
  const injectedLink = useGetLink();
  const link = injectedLink || ref(Links.End);
  
  // 获取 store，优先使用 inject，失败则尝试从当前实例获取
  let store = inject('$store', null);
  if (!store) {
    const instance = getCurrentInstance();
    store = instance?.proxy?.$store;
  }

  const detailState = reactive({
    list: [],
    innerList: [],
    index: 0,
  });
  const isAll = ref(true);
  if ([Links.Rectification, Links.Examine].includes(link.value)) {
    isAll.value = false;
  }
  const myList = computed(() => {
    if (isAll.value) return detailState.list;
    return detailState.list.filter((item) => {
      return item.status === 2;
    });
  });
  const getMyinnerList = (innerList) => {
    // innerList may contain child items which don't have a direct `status` field,
    // instead their check data may be attached as `defaultFormData`.
    if (isAll.value) return innerList;
    return innerList.filter((item) => {
      // main-level items may carry `status`
      if (item && typeof item === "object") {
        if (item.status !== undefined) return item.status === ItemStatus["不符合"];
        if (item.defaultFormData && item.defaultFormData.status !== undefined)
          return item.defaultFormData.status === ItemStatus["不符合"];
      }
      return false;
    });
  };
  const back = () => {
    if ([Links.Rectification, Links.Examine].includes(link.value)) {
      detailState.index = 0;
    } else {
      detailState.index -= 1;
    }
  };
  const close = () => {
    emits("close");
  };
  const next = () => {
    if (detailState.index === detailState.list.length) {
      detailState.index = 0;
    } else {
      detailState.index += 1;
    }
  };
  const select = (item, index) => {
    const i = detailState.list.findIndex((d) => d.itemNo === item.itemNo);
    detailState.index = i + 1;
  };
  const title = computed(() => {
    const { index, list } = detailState;
    if (index === 0) {
      if ([Links.Rectification].includes(link.value)) return "状态：待整改";
      if ([Links.Examine].includes(link.value)) return "状态：整改后待审核";
      if ([Links.End].includes(link.value)) return "状态：整改通过";
      return "";
    }
    const item = list[index - 1];
    if (item) return item.itemNo + "、" + item.itemName;
    return "";
  });
  const getList = async () => {
    try {
      // ===== 核心逻辑:区分数据来源 =====
      // 1. 如果有 check_list -> 这是查看详情,直接用 check_list 重建数据结构
      // 2. 如果没有 check_list -> 这是新建任务,调用模板接口
      
      if (props.check_list && props.check_list.length > 0) {
        // ===== 场景一:查看已有任务详情 =====
        loadFromCheckList();
        return;
      }
      
      // ===== 场景二:新建任务,加载模板 =====
      const params = props.templateNo ? { templateNo: props.templateNo } : {};
      const cacheKey = params.templateNo || 'default';
      
      // 尝试从 Vuex 缓存获取模板数据
      // store 已经在函数顶部获取
      if (store) {
        const cachedTemplate = store.getters['dailyControl/getTemplateByKey'](cacheKey);
        if (cachedTemplate) {
          // console.log('使用缓存的模板数据');
          processTemplateData(cachedTemplate);
          return;
        }
      }
      
      // 缓存未命中，调用接口
      // console.log('从接口获取模板数据');
      const resp = await defaultTemplate(params);
      
      // 保存到缓存
      if (store && resp) {
        store.commit('dailyControl/setTemplateCache', { key: cacheKey, data: resp });
      }

      processTemplateData(resp);
    } catch (error) {
      console.error(error);
    }
  };
  
  // 提取模板数据处理逻辑为独立函数
  const processTemplateData = (resp) => {
    try {
      // 兼容不同的返回结构:resp.code/resp.data 或 直接数组
      const payload = resp && resp.code && resp.code === 200 ? resp.data : resp;

      // items 可能位于 payload.items,或者 payload 本身就是数组
      const itemsSrc = (payload && payload.items) || (Array.isArray(payload) ? payload : []);

      // 将后端字段映射为组件期望的字段
      const checks = {};
      if (props.check_list && props.check_list.length > 0) {
        props.check_list.forEach((element) => {
          const objKeys = Object.keys(element);
          objKeys.forEach((key) => {
            checks[key] = element[key];
          });
        });
      }

      detailState.list = itemsSrc.map((it) => {
        const itemNo = it.item_no || it.itemNo || it.itemNo || it.itemNo === 0 ? String(it.item_no || it.itemNo) : it.item_no || it.itemNo;
        const itemName = it.item_name || it.itemName || it.itemName || "";
        const childrenArr = Array.isArray(it.children) ? it.children : [];
        let status = it.status || 1;
        let zg = undefined;
        let zgcount = 0;

        // 如果外部带有 check_list，则基于 check_list 计算该主项的状态
        if (checks && checks[itemName]) {
          const children = checks[itemName];
          let bfh = 0;
          let yzg = 0;
          children.forEach((child) => {
            if (child.status === ItemStatus["不符合"]) bfh += 1;
            if (child.isZG) yzg += 1;
          });
          if (bfh > 0) {
            status = ItemStatus["不符合"];
            zg = bfh > yzg ? "待整改" : "已整改";
            zgcount = bfh;
          }
        }

        return {
          id: it.id || it._id,
          itemNo,
          itemName,
          reserved1: it.reserved1 || it.reserved_1,
          children: childrenArr.length || it.children_count || 0,
          star: it.star || it.importance || "",
          status,
          zg,
          zgcount,
          _raw: it,
        };
      });

      // 构建子项列表
      detailState.innerList = [];
      detailState.list.forEach((item) => {
        const src = item._raw || {};
        const childrenArr = Array.isArray(src.children) ? src.children : [];
        const d = {
          key: item.itemNo,
          list: childrenArr.map((ch, chIndex) => {
            const childNo = ch.item_no || ch.itemNo || ch.itemNo || ch.item_no === 0 ? String(ch.item_no || ch.itemNo) : ch.item_no || ch.itemNo;
            const childName = ch.item_name || ch.itemName || "";
            const mapped = {
              id: ch.id || ch._id || `${item.itemNo}-${childNo || chIndex}`, // 确保有唯一ID
              itemNo: childNo,
              itemName: childName,
              option_id: ch.option_id || ch.optionId || ch.option || "",
              inputType: ch.input_type || ch.inputType || ch.input || 1,
              parentName: item.itemName,
              star: ch.star || ch.importance || "low",
            };
            // 如果有 checks，则尝试把默认表单数据挂载到子项上
            if (checks && checks[item.itemName]) {
              const childs = checks[item.itemName];
              if (childs) {
                const chi = childs.filter((c) => c.itemNo === mapped.itemNo || c.itemNo === mapped.itemNo || c.itemNo === mapped.itemNo);
                if (chi.length > 0) {
                  // attach a clone to avoid mutating original source
                  const df = Object.assign({}, chi[0]);
                  // normalize status into ItemStatus numeric value
                  if (df.status !== undefined && df.status !== null) {
                    // status might be numeric, numeric-string, or chinese text
                    const s = df.status;
                    // if already a number, use it
                    if (typeof s === "number") {
                      df.status = s;
                    } else if (/^\d+$/.test(String(s))) {
                      df.status = Number(s);
                    } else if (typeof s === "string") {
                      const trim = s.trim();
                      if (trim === "符合") df.status = ItemStatus["符合"];
                      else if (trim === "不符合") df.status = ItemStatus["不符合"];
                      else if (trim === "不适用") df.status = ItemStatus["不适用"];
                      else {
                        // fallback: try to parse known english words or leave as-is
                        const low = trim.toLowerCase();
                        if (low === "ok" || low === "pass" || low === "符合") df.status = ItemStatus["符合"];
                        else if (low === "fail" || low === "不符合") df.status = ItemStatus["不符合"];
                        else {
                          // leave numeric fallback or undefined
                          const n = Number(trim);
                          df.status = Number.isFinite(n) ? n : df.status;
                        }
                      }
                    }
                  }
                  mapped.defaultFormData = df;
                }
              }
            }
            return mapped;
          }),
        };
        detailState.innerList.push(d);
      });
    } catch (error) {
      console.error('处理模板数据出错:', error);
    }
  };
  // ===== 从 check_list 重建数据结构 =====
  const loadFromCheckList = async () => {
    // check_list 格式: [{ "主项名称": [子项数组] }]
    const checkMap = {};
    props.check_list.forEach((item) => {
      Object.keys(item).forEach((key) => {
        checkMap[key] = item[key];
      });
    });

    // 获取模板数据以获取重要性信息
    let templateData = null;
    try {
      const params = props.templateNo ? { templateNo: props.templateNo } : {};
      const cacheKey = params.templateNo || 'default';
      
      // store 已经在函数顶部获取
      if (store) {
        templateData = store.getters['dailyControl/getTemplateByKey'](cacheKey);
        if (!templateData) {
          const resp = await defaultTemplate(params);
          templateData = resp;
          store.commit('dailyControl/setTemplateCache', { key: cacheKey, data: resp });
        }
      }
    } catch (error) {
      console.warn('获取模板数据失败，使用默认重要性', error);
    }

    // 创建模板数据映射，用于查找重要性
    const templateMap = {};
    if (templateData) {
      const payload = templateData && templateData.code && templateData.code === 200 ? templateData.data : templateData;
      const items = (payload && payload.items) || (Array.isArray(payload) ? payload : []);
      
      items.forEach((item) => {
        const itemName = item.item_name || item.itemName || '';
        templateMap[itemName] = {
          star: item.star || item.importance || 'low',
          children: {}
        };
        
        // 映射子项的重要性
        if (Array.isArray(item.children)) {
          item.children.forEach((child) => {
            const childName = child.item_name || child.itemName || '';
            const childNo = String(child.item_no || child.itemNo || '');
            templateMap[itemName].children[childNo] = {
              star: child.star || child.importance || 'low'
            };
          });
        }
      });
    }

    // 重建主项列表
    const mainItems = Object.keys(checkMap).map((itemName, index) => {
      const children = checkMap[itemName];
      let notConformCount = 0;
      let rectifiedCount = 0;
      
      children.forEach((child) => {
        if (child.status === ItemStatus["不符合"]) notConformCount++;
        if (child.isZG) rectifiedCount++;
      });

      const status = notConformCount > 0 ? ItemStatus["不符合"] : ItemStatus["符合"];
      const zg = notConformCount > rectifiedCount ? "待整改" : "已整改";

      // 从模板映射中获取重要性，如果没有则默认为 'low'
      const star = templateMap[itemName]?.star || 'low';

      return {
        id: `main-${index}`,
        itemNo: children[0]?.itemNo?.split('.')[0] || String(index + 1),
        itemName,
        children: children.length,
        status,
        zg: notConformCount > 0 ? zg : undefined,
        zgcount: notConformCount,
        star: star,
      };
    });

    detailState.list = mainItems;

    // 重建子项列表
    detailState.innerList = mainItems.map((mainItem) => {
      const children = checkMap[mainItem.itemName];
      return {
        key: mainItem.itemNo,
        list: children.map((child, childIndex) => {
          // 从模板映射中获取子项的重要性
          const childNo = String(child.itemNo || '');
          const childStar = templateMap[mainItem.itemName]?.children?.[childNo]?.star || child.star || 'low';
          
          return {
            ...child,
            id: child.id || `${mainItem.itemNo}-${child.itemNo || childIndex}`, // 确保有唯一ID
            parentName: mainItem.itemName,
            defaultFormData: child,  // 将 check_list 的数据作为默认表单数据
            star: childStar,  // 添加重要性字段
          };
        }),
      };
    });
  };

  // 不再需要单独的 getChildList:子项由 defaultTemplate 返回并在 getList 中处理
  watch(
    [() => props.templateNo, () => props.check_list],
    () => {
      // 总是尝试加载模板：若 props.templateNo 为空则获取系统默认模板
      getList();
    },
    {
      immediate: true,
      deep: true, // 深度监听 check_list 数组变化
    }
  );
  /**收集到的数据全放这里面 */
  const dataList = ref([]);
  const setDataList = (data, name) => {
    const arr = dataList.value.filter((item) => {
      return !!item[name];
    });
    if (arr && arr.length > 0) {
      arr[0][name].push(data);
    } else {
      dataList.value.push({
        [name]: [data],
      });
    }
  };
  provide("SetData", {
    setDataList,
  });
  function submit() {
    // 验证所有不符合项是否填写了不符合原因
    let hasError = false;
    
    dataList.value.forEach((item) => {
      Object.keys(item).forEach((key) => {
        const children = item[key];
        if (Array.isArray(children)) {
          children.forEach((child) => {
            // 如果状态是"不符合"，则必须填写不符合原因
            if (child.status === ItemStatus["不符合"]) {
              if (!child.content || child.content.trim() === "") {
                hasError = true;
                message.error(`${child.itemNo}、${child.itemName} - 不符合原因不能为空！`);
              }
              if (!child.date) {
                hasError = true;
                message.error(`${child.itemNo}、${child.itemName} - 整改期限不能为空！`);
              }
            }
          });
        }
      });
    });
    
    // 如果有错误，阻止提交
    if (hasError) {
      return;
    }
    
    (dataList.value);
    emits("submit", dataList.value);
  }
  return {
    detailState,
    back,
    next,
    close,
    select,
    title,
    link,
    myList,
    getMyinnerList,
    isAll,
    submit,
  };
}
